import { NetworkRequestState } from '../baseTypes';
import { AuthorizedAppsWidgetData } from './types';

export const defaultAuthorizedAppsWidgetState: AuthorizedAppsWidgetData = {
  authorizedApps: [],
  request: {
    status: NetworkRequestState.IDLE,
    errors: {},
  },
};
